import React from "react"

class Layout extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            section_active : ""
            }
    }

    render() {
        return (
            <div className="layout">
                
            </div>
        )
    }

}


export default Layout


// WEBPACK FOOTER //
// ./src/Setup/modules/legal/Layout.js